/* eslint-disable react/jsx-filename-extension */
import React, { lazy } from 'react'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import { get as getConfig } from 'config'
import { isExperimentVariationActive } from 'services/optimizely'
import {
  URL_PLAN_SELECTION,
  URL_PLAN_SELECTION_PLANS,
  URL_ACCOUNT_CREATION,
  URL_CART_ACCOUNT_CREATION_CREATE,
  URL_CART_BILLING,
  URL_CART_BILLING_PAYMENT,
  URL_CART_CONFIRMATION,
  URL_EMAIL_SETTINGS,
  URL_AMBASSADORS,
  URL_ACCOUNT_INVOICE,
  URL_REMOTE_ACCOUNT_CREATE,
  URL_CHECKOUT,
  URL_LOGIN_WITH_LINK,
} from 'services/url/constants'
import { useSelector } from 'react-redux'
import { selectIsGiftCompatible, selectIsGiftCompatibleMultipleCurrency } from 'services/gift/selectors'

// single page checkout toggle
const isSinglePageCheckoutActive = !!getConfig().features.singlePageCheckout
const giftMultipleCurrenciesActive = !!getConfig().features.gift.multipleCurrencies

const LoadableHeader = lazy(
  () => import('components/Header'),
)

function isFullPlayer (location) {
  const { query } = location
  return !!_get(query, 'fullplayer')
}

function headerHidden (location) {
  const pathnames = [
    '/give',
    '/give/email-submit',
    '/give/video',
    '/cancel-offer-modal',
    '/get-started',
    '/ama/chat-popout', // Hide header for standalone chat popout
    URL_EMAIL_SETTINGS,
    URL_ACCOUNT_INVOICE,
    URL_LOGIN_WITH_LINK,
    ...(isSinglePageCheckoutActive ? [URL_CHECKOUT] : []),
  ]

  if (!getConfig().features.partnerDashboard) {
    pathnames.push(URL_AMBASSADORS)
  }

  if (location.pathname.startsWith('/share/')) {
    return true
  }

  return _includes(pathnames, location.pathname)
}

function headerHiddenByExperiment (location, experimentId, variationId) {
  return _includes(['/cart/account-creation', '/get-started'], location.pathname)
    && isExperimentVariationActive(experimentId, variationId)
}

function hideNavBar (location) {
  const pathnames = [
    URL_PLAN_SELECTION,
    URL_PLAN_SELECTION_PLANS,
    URL_ACCOUNT_CREATION,
    URL_CART_ACCOUNT_CREATION_CREATE,
    URL_CART_BILLING,
    URL_CART_BILLING_PAYMENT,
    URL_CART_CONFIRMATION,
    URL_EMAIL_SETTINGS,
    URL_ACCOUNT_INVOICE,
    URL_REMOTE_ACCOUNT_CREATE,
    '/get-started',
    '/give',
    '/give/email-submit',
    '/give/video',
    '/who-is-watching',
  ]
  return _includes(pathnames, location.pathname)
}

function hideUserMenu (location) {
  const pathnames = [
    URL_PLAN_SELECTION,
    URL_PLAN_SELECTION_PLANS,
    URL_ACCOUNT_CREATION,
    URL_CART_ACCOUNT_CREATION_CREATE,
    URL_CART_BILLING,
    URL_CART_BILLING_PAYMENT,
    URL_ACCOUNT_INVOICE,
    URL_REMOTE_ACCOUNT_CREATE,
    '/get-started',
    '/give',
    '/give/email-submit',
    '/give/video',
    '/who-is-watching',
  ]
  return _includes(pathnames, location.pathname)
}

function hideLogin (location) {
  return _includes([
    URL_CART_BILLING_PAYMENT,
    URL_ACCOUNT_INVOICE,
    URL_CART_BILLING,
    URL_REMOTE_ACCOUNT_CREATE,
    '/give/email-submit',
    '/give/video',
    '/give',
  ], location.pathname)
}

function renderHeaderComponent (props) {
  const isUserGiftCompatible = useSelector(
    giftMultipleCurrenciesActive ? selectIsGiftCompatibleMultipleCurrency : selectIsGiftCompatible,
  )
  const { history, location } = props
  if (isFullPlayer(location)
    || headerHidden(location)
    || headerHiddenByExperiment(location, '9622812567')) {
    return null
  }
  return (
    <LoadableHeader
      history={history}
      location={location}
      hideLogin={hideLogin(location)}
      hideNavBar={hideNavBar(location)}
      hideUserMenu={hideUserMenu(location)}
      isGiftCompatible={isUserGiftCompatible}
    />
  )
}

export default [
  { path: '*', component: renderHeaderComponent },
]
